import React from 'react'
import { Box } from '@mui/material'

import { WrestlerItem } from './wrestler'
import { AvatarStack } from '../../namebar'

export function AppearanceItem(props) {
  const {
    children = null,
    winner,
    manager,
    wrestler
  } = props
  
    // winner && !manager && (<Chip color="success"
    //   label="Winner"
    //   icon={<WinnerIcon />} />)
  
  if (manager) {
    return (
      <Box>
        <AvatarStack collection={[wrestler]} />
        <Box>{children}</Box>
      </Box>
    )
  }
  
  return (
    <Box sx={{
      backgroundColor: winner ? 'green' : 'inherit'
    }}>
      <WrestlerItem {...wrestler} />
      <Box>{children}</Box>
    </Box>
  )
}
